import React, { useEffect, useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Label } from 'recharts';
import { useLazyGetDashboardSearchQuery } from '../../../../services/Api';
import LoaderSpiner from '../../../../components/loaderSpiner';

const COLORS = ['#5D733C', '#F2D53F', "#EF476F", "#8338EC", "#3A86FF"];

const GenderDistribution = () => {
    const [trigger, { data, isLoading, error }] = useLazyGetDashboardSearchQuery();
    const [chartData, setChartData] = useState([]);

    useEffect(() => {
        trigger()
            .unwrap()
            .then((response) => {
                const genderStats =
                    response?.data?.usersStats?.UsersStats?.[0]?.genderWise || [];
                const formattedData = genderStats.map((item) => ({
                    name:
                        item.gender.charAt(0).toUpperCase() +
                        item.gender.slice(1).toLowerCase(),
                    value: item.count,
                }));
                setChartData(formattedData);
            })
            .catch((err) => {
                // console.error("Error fetching data:", err);
            });

    }, [trigger]);

    if (isLoading) return <p><LoaderSpiner /></p>;
    if (error) return <p>Error loading data.Please Try again later</p>;

    return (
        <div className="bg-lightgreen p-6 rounded-[1.75rem] h-full">
            <h3 className="text-lg mb-4 font-roboto-mono text-[18px] font-bold">Gender Distribution</h3>
            <div className="h-64">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={60}
                            outerRadius={80}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {chartData.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                            <Label
                                value="100%" // Always display 100% in the center
                                position="center"
                                className="font-bold text-xl"
                                style={{ fontSize: '24px', fill: '#333' }}
                            />
                        </Pie>
                        <Tooltip />
                    </PieChart>
                </ResponsiveContainer>
            </div>
            <div className="flex justify-center gap-4 mt-4">
                {chartData?.map((item, index) => (
                    <div key={item.name} className="flex items-center gap-2">
                        <div className="w-3 h-3 rounded-full" style={{ backgroundColor: COLORS[index % COLORS.length] }}></div>
                        <span className="text-sm">{item.name}</span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GenderDistribution;
